<template>
  <intersect @enter="animate = true" :threshold="[0, 0.25, 0.5, 0.75, 1]">
    <section class="container discover-container fadeUp" :class="animate ? 'animate' : ''" v-if="itemData">
    <div class="flex-box between pt-144">
      <router-link :is="aHref ? 'a' : 'router-link'" v-bind="parseUrl(_.get(item,'smartbuttons.0.url'))" class="row-box img-box br-12" v-for="item in itemData" :key="item.key">
        <picture>
          <source
            media="(max-width: 767px)"
            :srcset="_.get(item, 'cover_image.0.devices.mobile')"
          />
          <source
            media="(max-width: 1023px)"
            :srcset="_.get(item, 'cover_image.0.devices.tablet')"
          />
          <img :src="_.get(item, 'cover_image.0.devices.desktop')" class="img-absolute br-12" :alt="item.title" />
        </picture>
        <div class="box-content">
          <h2 class="main-title white">{{item.title}}</h2>
          <div class="btn sub bg-white mt-21">{{_.get(item,'smartbuttons.0.title')}}</div>
        </div>
        <div class="img-overlay br-12"></div>
      </router-link>
    </div>
  </section>
  </intersect>
</template>


<script>
  import Intersect from "vue-intersect";
export default {
  data(){
    return {
      animate:false,
      aHref : true
    }
  },
  components: { Intersect },
  props: {
    itemData: Array,
    required: true,
  },
  methods: {
    parseUrl (url) {
      if(url.indexOf("http") == 0){
        let bind = {
          href: url
        }
        this.aHref == true
        return bind
      }else{
        let bind = {
          href: url
        }
        this.aHref == false
        return bind
      }
    }
  }
};
</script>
